import * as marietta from '../..';
import { ItemControllerStair } from '.';
import { SVGSprite } from '../flash/display';

/**
 * モバイル用階段itemcontrollerクラス
 */
class ItemControllerStairMobile extends ItemControllerStair {
  stairDragger: marietta.webcad.control.parts.RoomDraggerMobile;

  dragStartPoint: marietta.core.Point;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    super(_target);
    // 移動Dragger
    this.stairDragger = new marietta.webcad.control.parts.RoomDraggerMobile(this.spt);
    this.stairDragger.dragFunc = this.onMoveStairDragger;
    this.stairDragger.dragEndFunc = this.onMoveEndStairDragger;
    this.stairDragger.move(0, 0);
    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      if (this.target.itemInfo.lock) {
        this.hideToolTips();
      } else {
        this.showToolTips();
      }
    }
  }

  /**
   * コントロールピッカーが移動された
   */
  moveControlPicker(e: MouseEvent, target: marietta.webcad.control.parts.ControlPicker) {
    super.moveControlPicker(e, target);
    // 移動軸
    this.stairDragger.move(this.dragObj_L.x + (this.dragObj_R.x - this.dragObj_L.x) / 2, this.dragObj_T.y + (this.dragObj_B.y - this.dragObj_T.y) / 2);
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveStairDragger = () => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfMove()) return;

    // 開始時のアイテム場所保持
    if (this.dragStartPoint === undefined || this.dragStartPoint === null) {
      // ピッカーの位置修正
      this.resizeToTarget();

      if (!this.emptySpt) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.stairDragger.spt);
        this.stairDragger.spt.parent.addChild(this.emptySpt);
      }

      // ドラッグの開始位置
      this.dragStartPoint = new marietta.core.Point(
        this.target.spt.mouseX * this.target.spt.scaleX,
        this.target.spt.mouseY * this.target.spt.scaleY,
      );

      // ドラッガーの元位置
      this.stairDragger.saveOriginalPoisition();
    }

    const newPoint: marietta.core.Point = new marietta.core.Point(
      marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX,
      marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY,
    );

    const moveX: number = newPoint.x - this.dragStartPoint.x;
    const moveY: number = newPoint.y - this.dragStartPoint.y;
    const snapPoint: marietta.core.Point = ItemControllerStairMobile.snapToGrid(moveX, moveY);

    // ターゲットの移動
    this.target.move(snapPoint.x, snapPoint.y);
    // ターゲットに吸着
    this.syncMeToTarget();
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndStairDragger = () => {
    this.dragStartPoint = null;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }
    // マウスアップの挙動
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
  }

  /**
   * ピッカーの更新
   */
  public updatePickers(): void {
    super.updatePickers();
    this.stairDragger.updateTranslate();
  }

  /**
   * グリッドに吸い付く
   * @param x
   * @param y
   * @returns
   */
  private static snapToGrid(x: number, y: number): marietta.core.Point {
    const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
    const _x = Math.round(x / snapUnit) * snapUnit;
    const _y = Math.round(y / snapUnit) * snapUnit;
    return new marietta.core.Point(_x, _y);
  }

  /**
   * ツールチップを非表示
   */
  hideToolTips() {
    this.btnDelete.hide();
    this.btnDragger.hide();
    this.btnReverse.hide();
    this.rotator.hide();
  }

  /**
   * ツールチップを表示する
   */
  showToolTips() {
    this.btnDelete.show();
    this.btnDragger.show();
    this.btnReverse.show();
    this.rotator.show();
  }
}
export default ItemControllerStairMobile;
